import React from "react";
import { TableHead, TableRow, TableCell, TableSortLabel } from "@material-ui/core";

export type Order = "asc" | "desc";

export interface IHeaderCell<TModel> {
  propName: keyof TModel;
  label: string;
  numeric: boolean;
  order?: Order;
  date?: boolean;
}

export interface ITableHeadProps<TModel> extends ITableHeadPropsWithoutSort<TModel> {
  onRequestSort: (cell: IHeaderCell<TModel>) => void;
}

export interface ITableHeadPropsWithoutSort<TModel> {
  cells: Array<IHeaderCell<TModel>>;
  rowCount: number;
}

export function TableHeaderWithoutSort<TModel>(props: ITableHeadPropsWithoutSort<TModel>) {
  return (
    <TableHead>
      <TableRow>
        {props.cells.map(hc => (
          <TableCell key={hc.propName as string | number | undefined}>{hc.label}</TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function TableHeader<TModel>(props: ITableHeadProps<TModel>) {
  const createSortHandler = (cell: IHeaderCell<TModel>) => (event: React.MouseEvent<unknown>) => {
    props.onRequestSort(cell);
  };

  return (
    <TableHead>
      <TableRow>
        {props.cells.map(hc => (
          <TableCell key={hc.propName as string | number | undefined} sortDirection={hc.order || false}>
            <TableSortLabel active={!!hc.order} direction={hc.order} onClick={createSortHandler(hc)}>
              {hc.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default TableHeader;
